import { useEffect, useState } from "react";

function placesReady() {
  return Boolean(window.google?.maps?.places);
}

// The vehicles map can load the Maps API before a zone page does. importLibrary
// adds Places onto that already loaded API so location search can mount.
export function usePlacesLibrary(isLoaded: boolean) {
  const [ready, setReady] = useState(placesReady);

  useEffect(() => {
    if (!isLoaded) {
      return;
    }
    if (placesReady()) {
      setReady(true);
      return;
    }

    const maps = window.google?.maps as
      | (typeof google.maps & {
          importLibrary?: (name: string) => Promise<unknown>;
        })
      | undefined;
    if (!maps?.importLibrary) {
      return;
    }

    let cancelled = false;
    maps
      .importLibrary("places")
      .then(() => {
        if (!cancelled) {
          setReady(true);
        }
      })
      .catch((error) => {
        console.error("Failed to load the Google Maps Places library", error);
      });

    return () => {
      cancelled = true;
    };
  }, [isLoaded]);

  return ready;
}
